import axios from '../../config/axios';


const apigetCredit = async () => {
  try {
    const result = await axios.get(`/app/profile/credit`,{headers: {
      Authorization: "Bearer " + localStorage.getItem("rondori_token"),
    }})
    return result && result.data
  } catch (error) {
    return error && error.response && error.response.data
  }
}

const apiGetHistory = async () => {
  try {
      const result = await axios.get(`/app/profile/history`,{headers: {
        Authorization: "Bearer " + localStorage.getItem("rondori_token"),
      }})
      return result && result.data
    } catch (error) {
      return error && error.response && error.response.data
    }
}

const apiGetDeepToken = async () => {
  try {
      const result = await axios.get(`/app/auth/deep_token?nonce=`+localStorage.getItem("rondori_nonce"),{})
      return result && result.data
    } catch (error) {
      return error && error.response && error.response.data
    }
}

export {
  apigetCredit,
  apiGetHistory,
  apiGetDeepToken
}